<div class="container">

<app-smpte-calculator></app-smpte-calculator>

</div>